var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.246f47f43140cf999837315e64922bb6.svg#k';
                    var viewUrl = 'sprites.246f47f43140cf999837315e64922bb6.svg#view-k';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 19 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };